import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { Columns } from 'src/app/models/responses/dataStoreResponse';
import { AppCardComponent } from '../app-card/app-card.component';
import { CustomFilterComponent } from './custom-filter/custom-filter.component';
import { CustomTypeSelectComponent } from './custom-filter/custom-type-select.component';

@Component({
  selector: 'app-ag-grid-table',
  templateUrl: './ag-grid-table.component.html',
  styleUrls: ['./ag-grid-table.component.scss']
})
export class AgGridTableComponent implements OnInit, OnChanges {
  _rowData: any[] = [
    { make: 'Toyota', model: 'Celica', price: 35000 },
    { make: 'Ford', model: 'Mondeo', price: 32000 },
    { make: 'Porsche', model: 'Boxster', price: 72000 }
  ];

  @Output() menuEvent: EventEmitter<any> = new EventEmitter();


  _columnTypes: Columns[] = [];
  @Input() set columnTypes(value: Columns[]) {
    this._columnTypes = value
    this.createHeaderWithType()
  }
  columnDefs: ColDef[] = [];
  private gridApi!: GridApi;
  @Input() height: string = '100%';
  @Input() typeSelect: boolean = false

  @Input()
  set rowData(value: any[]) {
    if (!value || value.length === 0) return;

    this._rowData = value;

    // Eğer grid API hazırsa, yeni veriyi ayarla
    if (this.gridApi) {
      this.gridApi.setRowData(value);
    }

    this.createHeaderWithType()

  }

  get rowData(): any[] {
    return this._rowData;
  }

  // Tüm kolonlar için varsayılan ayarlar
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true, // Yerleşik filtreleme etkin
    resizable: true,
    suppressMenu: false, // Menüyü göster
    filterParams: {
      buttons: ['apply', 'clear'],
      closeOnApply: true
    },
    suppressAutoSize: true,
    minWidth: 200
  };

  public gridOptions = {
    defaultColDef: this.defaultColDef,
    context: {
      componentParent: this, // CustomTypeSelectComponent içinden erişmek için
    },
    overlayNoRowsTemplate: '<span class="no-rows">Veri Yok</span>',
    icons: {
      menu: this.typeSelect ?
        `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
</svg>`
        :
        `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
</svg>`
    }
  };

  constructor() { }

  ngOnInit(): void {
    // Özel menü yönetimi yerine ag-Grid'in yerleşik menüsünü kullan
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Değişiklik kontrolü
  }

  // Grid hazır olduğunda çağrılır
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;

    // Kolon boyutlarını ayarla
    params.api.sizeColumnsToFit();



    // Eğer başlangıçta veri varsa, kolonları ayarla
    if (this._rowData && this._rowData.length > 0 && this.columnDefs.length === 0) {
      // rowData setter'ını tekrar çağır
      this.rowData = this._rowData;
    }


  }


  attachClickEventToHeaders() {
    document.querySelectorAll('.custom-header-icon').forEach((element) => {
      element.addEventListener('click', (e) => { console.log('e', e) });
    });
  }


  createHeaderWithType() {
    if (this.typeSelect) {
      this.gridOptions.icons.menu = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
    </svg>`
    }

    // Kolon tanımlarını oluştur
    if (this._rowData[0] && this._columnTypes.length > 0) {
      this.columnDefs = Object.keys(this._rowData[0]).map((key) => {
        var selectedtype = this._columnTypes.find(x => x.fieldName == key)?.fieldType?.toLowerCase() || '';
        var selectedtag = this._columnTypes.find(x => x.fieldName == key)?.tags?.toLowerCase() || '';

        const suppressMenu = selectedtag.length > 0 || this.typeSelect ? false : true



        var icon = selectedtype.includes('string') ? 'Text' :
          selectedtype.includes('number') ? 'Numbers' :
            selectedtype.includes('fx') ? 'fx' :
              selectedtype.includes('date') ? 'Calendar' : 'Calendar';

        // İkon ile başlık 
        const headerComponent = {
          template: `
            <div class="ag-cell-label-container" role="presentation">
            ${suppressMenu ? '' : '<span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>'}
              <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                <img width="16px" src='/assets/images/icons/${icon}.png' class="custom-header-icon" data-field="${key}"/>
                <span ref="eText" class="ag-header-cell-text">${key}</span>
                
              </div>
            </div>
          `
        };


        return {
          headerName: key,
          field: key,
          sortable: true,
          suppressMenu: suppressMenu,
          filter: this.typeSelect ? CustomTypeSelectComponent : CustomFilterComponent, // Grid'in yerleşik filtresini kullan
          filterParams: {
            text: selectedtag,
            title: key
          },
          headerComponentParams: headerComponent,
        };
      });
      setTimeout(() => this.attachClickEventToHeaders(), 100);

      // Eğer grid API hazırsa, kolon tanımlarını güncelle
      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.columnDefs);
      }
    }
  }
  //custom type select içinden tetikleniyoe
  applyMenuSelection(data: { colId: string, type: string }) {
    this.menuEvent.emit(data)
  }

}